import { render, staticRenderFns } from "./preview-component-visitor-employee-management.vue?vue&type=template&id=4c9a6d70&scoped=true&"
import script from "./preview-component-visitor-employee-management.vue?vue&type=script&lang=js&"
export * from "./preview-component-visitor-employee-management.vue?vue&type=script&lang=js&"
import style0 from "./preview-component-visitor-employee-management.vue?vue&type=style&index=0&id=4c9a6d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a6d70",
  null
  
)

export default component.exports